import { Form, DatePicker, TimePicker, Button, Space, message, Modal, Alert } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { Link } from "react-router-dom";
moment.locale("es-mx");

export default function AddVisitForm(props) {
  const { id, setVisits, visible, setVisible } = props;
  const [form] = Form.useForm();
  const [overlappingVisits, setOverlappingVisits] = useState([]);

  const checkOverlapping = () => {
    const fecha = form.getFieldValue("FechaVisita");
    const inicio = form.getFieldValue("HoraInicio");
    const termino = form.getFieldValue("HoraTermino");

    if (fecha && inicio && termino) {
      const startTimestamp = moment(fecha).format("YYYY-MM-DD") + " " + moment(inicio).format("HH:mm:ss");
      const endTimestamp = moment(fecha).format("YYYY-MM-DD") + " " + moment(termino).format("HH:mm:ss");

      console.log("Checking for overlaps with:", { startTimestamp, endTimestamp });

      axios
        .get(`${process.env.REACT_APP_API_URL}/visitas/timeoverlap/${startTimestamp}/${endTimestamp}`)
        .then((res) => {
          console.log("Overlapping visits API response:", res.data);
          setOverlappingVisits(res.data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Error al verificar visitas superpuestas");
        });
    } else {
      console.log("Fecha, HoraInicio, or HoraTermino is missing.");
      setOverlappingVisits([]); // Clear overlaps if inputs are incomplete
    }
  };

  useEffect(() => {
    visible && form.resetFields();
    checkOverlapping();
  }, [visible, form]);

  const onSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        axios
          .post(`${process.env.REACT_APP_API_URL}/visitas`, {
            VerificacionID: id,
            FechaVisita: moment.utc(values.FechaVisita).format("YYYY-MM-DD"),
            HoraInicio: moment(values.HoraInicio, "HH:mm:ss").format("HH:mm:ss"),
            HoraTermino: moment(values.HoraTermino, "HH:mm:ss").format("HH:mm:ss"),
          })
          .then((res) => {
            setVisible(false);
            message.success("Visita agregada");
            axios
              .get(`${process.env.REACT_APP_API_URL}/visitas/${id}`)
              .then((res) => {
                setVisits(res.data);
                message.success("Lista de visitas actualizada");
              })
              .catch((err) => {
                console.log("Error al obtener las visitas", err);
                message.error("Error al obtener las visitas");
              });
          })
          .catch((err) => {
            console.log("Error al agregar la visita", err);
            message.error("Error al agregar la visita");
          });
      })
      .catch((err) => {
        console.log(err);
        message.error("Error al validar los campos");
      });
  };

  return (
    <>
      <Modal title="Agregar Visita" visible={visible} onCancel={() => setVisible(false)} footer={null}>
        <Form form={form} layout="vertical" onValuesChange={checkOverlapping}>
          <Form.Item name="FechaVisita" label="Fecha de la visita" rules={[{ required: true, message: "Escriba la fecha de la visita" }]}>
            <DatePicker format={"DD/MM/YYYY"} style={{ width: "50%" }} disabledDate={(current) => current && current > moment().endOf("day")} />
          </Form.Item>
          <Form.Item name="HoraInicio" label="Hora de inicio" rules={[{ required: true, message: "Seleccione la hora" }]}>
            <TimePicker format="HH:mm" style={{ width: "50%" }} minuteStep={5} disabledTime={() => ({ disabledHours: () => [0, 1, 2, 3, 4, 5, 6, 21, 22, 23] })} />
          </Form.Item>
          <Form.Item name="HoraTermino" label="Hora de Término" rules={[{ required: true, message: "Seleccione la hora" }]}>
            <TimePicker format="HH:mm" style={{ width: "50%" }} minuteStep={5} disabledTime={() => ({ disabledHours: () => [0, 1, 2, 3, 4, 5, 6, 21, 22, 23] })} />
          </Form.Item>
        </Form>
        {overlappingVisits.length > 0 && (
          <Alert
            message="Visitas superpuestas"
            description={
              <ul>
                {overlappingVisits.map((visit) => (
                  <li key={visit.VerificacionID}>
                    Control Interno:{" "}
                    <Link to={`/verificaciones/${visit.VerificacionID}`}>
                      {visit.ControlInterno}
                    </Link>
                    {` - Inicia: ${visit.IniciaVisita}, Termina: ${visit.TerminaVisita}`}
                  </li>
                ))}
              </ul>
            }
            type="warning"
            showIcon
            style={{ marginBottom: "16px" }}
          />
        )}
        <Space>
          <Button
            type="primary"
            onClick={() => {
              onSubmit();
            }}
          >
            Agregar
          </Button>
          <Button
            type="primary"
            onClick={() => {
              setVisible(false);
              form.resetFields();
            }}
          >
            Cancelar
          </Button>
        </Space>
      </Modal>
    </>
  );

}
